import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PlayerCard from './PlayerCard';
import { tournamentStageMap } from 'constants/Tournament';

const ResultsCard = ({ data, page }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const {
    type,
    match_date: date,
    team1_id,
    team2_id,
    ch_set1,
    ch_set2,
    ch_set3,
    op_set1,
    op_set2,
    op_set3,
    ch_tb1,
    op_tb1,
    ch_tb2,
    op_tb2,
    ch_tb3,
    op_tb3,
    team1_player1_id,
    team1_player2_id,
    team2_player1_id,
    team2_player2_id,
    team1_player1,
    team1_player2,
    team2_player1,
    team2_player2,
    team1_player1_image,
    team1_player2_image,
    team2_player1_image,
    team2_player2_image,
    match_number,
    place,
    stage,
    level_name,
    level_id,
    gender_id,
    type_name,
    tournament_name,
    tournament_id,
    score_team1,
    score_team2,
    winner_team_id,
    loser_team_id,
  } = data;

  const tournamentStage = (tournamentStage, matchNumber) => {
    const stage = tournamentStageMap[tournamentStage];
    if (typeof stage === 'string') {
      return stage;
    } else {
      return stage ? stage[matchNumber] : undefined;
    }
  };

  const players = [
    {
      userId: team1_player1_id,
      fullName: team1_player1,
      avatar: team1_player1_image,
      partnerId: team1_player2_id,
      partnerFullName: team1_player2,
      partnerAvatar: team1_player2_image,
      set1: ch_set1,
      set2: ch_set2,
      set3: ch_set3,
      tb1: ch_tb1,
      tb2: ch_tb2,
      tb3: ch_tb3,
      isWinner: winner_team_id === team1_id,
    },
    {
      userId: team2_player1_id,
      fullName: team2_player1,
      avatar: team2_player1_image,
      partnerId: team2_player2_id,
      partnerFullName: team2_player2,
      partnerAvatar: team2_player2_image,
      set1: op_set1,
      set2: op_set2,
      set3: op_set3,
      tb1: op_tb1,
      tb2: op_tb2,
      tb3: op_tb3,
      isWinner: winner_team_id === team2_id,
    },
  ];

  return (
    <Box
      sx={{
        width: { xs: '100%', md: 'auto' },
        height: { xs: '100%', md: 'auto' },
        backgroundColor: theme.palette.base.white,
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '16px',
        boxShadow: '0px 2px 13px 0px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="body5"
          fontWeight={600}
          color={theme.palette.darkGrey[400]}
        >
          {page === 'tournaments' ? tournamentStage(stage, match_number) : type}
        </Typography>
        <Typography
          variant="body5"
          fontWeight={600}
          color={theme.palette.darkGrey[400]}
        >
          {date}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          marginTop: '12px',
          flexDirection: 'column',
        }}
      >
        {players.map((player, index) => (
          <PlayerCard key={index} {...player} />
        ))}
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: page === 'tournaments' ? 'pointer' : 'default',
        }}
        onClick={() => {
          if (page === 'tournaments') {
            navigate(`/turnyras/${tournament_id}`, {
              state: {
                tournament_id,
                tournament_name,
                level_id,
                tournament_level: level_name,
                tournament_stage: stage,
                gender_id,
                tournament_gender: type_name,
              },
            });
          }
        }}
      >
        <Typography
          variant="body5"
          fontWeight={600}
          color={theme.palette.darkGrey[400]}
          marginTop="12px"
        >
          {page === 'tournaments' ? tournament_name : place}
        </Typography>
        <Typography
          variant="body5"
          fontWeight={600}
          color={theme.palette.darkGrey[400]}
        >
          {page === 'tournaments' ? level_name : ''}
        </Typography>
      </Box>
    </Box>
  );
};

export default ResultsCard;
